export type AssetOrigin = CloudAssetOrigin | OnPremAssetOrigin;

export enum CloudAssetOrigin {
    User = 1,
    System = 2
}

export enum OnPremAssetOrigin {
    User = 1,
    System = 2
}
